module.exports = {
	"ha": "vcha",
	"id": 2.3,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 640,
			"height": 870,
			"marginLeft": 100,
			"marginRight": 60,
			"marginBottom": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 2.3</span>                 <span style=\"display: table-cell;\">Rate of HIV Testing by Age Category for Vancouver Coastal Health <sup style=\"font-size: 10px;\">2</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					2009,
					2010,
					2011,
					2012,
					2013,
					2014,
					2015,
					2016,
					2017
				],
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff"
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 1000,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "HIV Testing Episodes per 100,000 Population",
					"reserveSpace": false,
					"x": -90
				}
			}
		],
		"series": [
			{
				"name": "< 30",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					4308.688918530088,
					4297.144040806815,
					4494.511509983001,
					5499.428607129004,
					6646.135531372524,
					7622.142657600742,
					8455.212944863802,
					8724.153508141517,
					{
						"y": 9039.834987752996,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">< 30</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "30–39",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					7336.744479720754,
					7558.094511922704,
					7670.625285477318,
					9475.136981049725,
					12100.126091626582,
					14061.772466242433,
					15772.331616913427,
					16495.277593640756,
					{
						"y": 16337.24589512273,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">30–39</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "40–49",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					4521.288655119253,
					4441.705083391029,
					4655.287704146975,
					6214.396390648498,
					8939.517538748398,
					10842.517306929287,
					11993.721698028108,
					12292.119465676818,
					{
						"y": 11740.970256044908,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 0,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">40–49</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "≥ 50",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					1842.3596343450522,
					1910.205268955932,
					2189.786754984226,
					4164.246436183959,
					7248.2874241964455,
					10726.598456204776,
					12223.540180072478,
					12235.191009389564,
					{
						"y": 11580.508682812633,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 10,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">≥ 50</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_2_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_2_3.json
// module id = 291
// module chunks = 0